import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const mlaApartmentViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map